import { render, staticRenderFns } from "./taskDeliverList-01.vue?vue&type=template&id=97431030&scoped=true"
import script from "./taskDeliverList-01.vue?vue&type=script&lang=js"
export * from "./taskDeliverList-01.vue?vue&type=script&lang=js"
import style0 from "./taskDeliverList-01.vue?vue&type=style&index=0&id=97431030&prod&lang=css"
import style1 from "./taskDeliverList-01.vue?vue&type=style&index=1&id=97431030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97431030",
  null
  
)

export default component.exports